export enum InheritType {
	InheritFromCollection = 1,
	CopyFromCollection = 2,
	InheritFromFolder = 3,
	CopyFromFolder = 4,
	Custom = 5,
  InheritFromDataDesign = 6
}